import CustomTable from "../../components/CustomTable";
import PieChart from "../../components/PieChart";
import SearchAndFilterBar from "../../components/SearchAndFilterBar";
import Loading from "../../components/Loading";
import { EmptyChart, hasChartData } from "../../components/EmptyChart";
import Button from "../../components/Button";

const ServiceReportPresenter = ({
    loading,
    exporting,
    tempFromDate,
    tempToDate,
    setTempFromDate,
    setTempToDate,
    handleApplyFilter,
    handleExport,
    serviceReport,
    tableData,
    hasMore,
    loadingMore,
    loadMoreData
}) => {
    if (loading || exporting) return <Loading />;

    return (
        <div className="bg-white p-4 sm:p-6 border border-[#D2D5DA] rounded-[24px] flex flex-col gap-6 shadow-sm animate-in fade-in duration-500">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                <div>
                    <h2 className="text-2xl font-bold text-gray-800">Báo cáo dịch vụ</h2>
                    <p className="text-sm text-gray-500 mt-1">Phân tích chi tiết số lượng và hiệu suất dịch vụ</p>
                </div>

                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full lg:w-auto">
                    <SearchAndFilterBar
                        showSearch={false}
                        showAddButton={false}
                        showDateRangePickers
                        fromDateValue={tempFromDate}
                        toDateValue={tempToDate}
                        onFromDateChange={setTempFromDate}
                        onToDateChange={setTempToDate}
                        filterButton={true}
                        filterButtonVariant="primary"
                        filterLabel="Áp dụng"
                        onFilterClick={handleApplyFilter}
                    />

                    <Button
                        type="button"
                        variant="secondary"
                        size="lg"
                        onClick={handleExport}
                        disabled={exporting}
                        isLoading={exporting}
                        className="w-full sm:w-auto"
                        rightIcon={
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                        }
                    >
                        {exporting ? "Đang xuất..." : "Xuất file PDF"}
                    </Button>
                </div>
            </div>

            <div className="flex items-center justify-start w-full">
                <div className="bg-[#F5F5F5] border border-[#D2D5DA] rounded-[16px] px-6 py-4 inline-flex items-center gap-4 shadow-sm hover:shadow-md transition-all">
                    <span className="text-[#1a1a1a] text-sm sm:text-base font-medium whitespace-nowrap">Tổng số dịch vụ</span>
                    <div className="w-[1px] h-8 bg-[#D2D5DA]" />
                    <span className="font-bold text-[#1a1a1a] text-sm sm:text-base shrink-0">
                        {serviceReport?.summary?.totalServiceQuantity?.toLocaleString() || 0}
                    </span>
                </div>
            </div>

            <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
                <div className="xl:col-span-4 border border-[#E3E3E3] p-4 sm:p-6 rounded-[20px] flex items-center justify-center bg-gray-50/30 min-h-[400px]">
                    {hasChartData(serviceReport?.chart) ? (
                        <div className="w-full max-w-[280px]">
                            <PieChart data={serviceReport.chart} size={220} legendPosition="bottom" />
                        </div>
                    ) : (
                        <div className="py-20 text-center">
                            <EmptyChart title="Chưa có dữ liệu biểu đồ" />
                        </div>
                    )}
                </div>

                <div className="xl:col-span-8 min-w-0">
                    <CustomTable
                        columns={[
                            { title: "STT", render: (_, __, i) => i + 1, width: "60px" },
                            { key: "serviceName", title: "TÊN DỊCH VỤ", minWidth: "220px", cellClassName: "!whitespace-normal !overflow-visible break-words" },
                            { key: "quantity", title: "SỐ LƯỢNG", align: "right", render: (val) => <span className="font-semibold text-gray-900">{val?.toLocaleString() || 0}</span> },
                        ]}
                        data={tableData}
                        infinite={true}
                        loadMore={loadMoreData}
                        hasMore={hasMore}
                        loadingMore={loadingMore}
                        headerClassName="bg-[#0457C2] text-white uppercase text-xs"
                        setView={false}
                        setEdit={false}
                        setDelete={false}
                    />
                </div>
            </div>
        </div>
    );
};

export default ServiceReportPresenter;
